import { createEvent, createStore } from 'effector';

export const paletteOpened = createEvent();
export const paletteClosed = createEvent();
export const helpOpened = createEvent();
export const helpClosed = createEvent();

export const $paletteOpen = createStore(false)
  .on(paletteOpened, () => true)
  .on(paletteClosed, () => false)
  .on(helpOpened, () => false);

export const $helpOpen = createStore(false)
  .on(helpOpened, () => true)
  .on(helpClosed, () => false);
